import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Tab } from 'src/app/models/tabs/tabs';
import { MenuItem, SubMenuBase, SubMenuItem } from '../../models/menu-item';
import { MenuService } from '../../services/menu.service';
import { Store } from '../../store';

@Component({
    selector: 'app-inline-menu',
    templateUrl: './inline-menu.component.html',
    styleUrls: ['./inline-menu.component.scss'],
})
export class InlineMenuComponent implements OnInit {
    @Input() menuItems: Array<SubMenuBase | SubMenuItem> = undefined;
    @Input() themeCss: '--large' | '--small' = '--large';
    @Input() tabs: Tab[];
    @Output() menuClicked = new EventEmitter();
    @Output() emitSelectedTab: EventEmitter<Tab> = new EventEmitter<Tab>();
    panelIsOpen = false;
    public selectedTab: Tab;

    constructor(
        private _menuService: MenuService,
        public router: Router,
        private store: Store,
        private elementRef: ElementRef
    ) {}

    ngOnInit(): void {
        if (!this.menuItems) {
            this.menuItems = this.getInlineMenuItems(this.router.url.split('?')[0]).subMenus;
        }
    }

    private getInlineMenuItems(route: string): MenuItem {
        const menuItems: MenuItem[] = this.store.selectForLocal('menuItems');
        return menuItems.find((menuItem) => menuItem.subMenus.find((subMenuItem) => subMenuItem.route === route));
    }

    @HostListener('document:click', ['$event.target'])
    openDropdown(target) {
        setTimeout(() => {
            if (this.elementRef.nativeElement.contains(target)) {
                this.panelIsOpen = !this.panelIsOpen;
            } else {
                this.panelIsOpen = false;
            }
        }, 100);
    }

    public setSelectedTab(tabText: string) {
        const tabToSelect = this.tabs.find((tab: Tab) => tab.tabText === tabText);
        const priorSelectedTab = this.tabs.find((tab: Tab) => tab.isSelected);

        if (tabToSelect !== priorSelectedTab) {
            priorSelectedTab.isSelected = false;
            tabToSelect.isSelected = true;
            this.selectedTab = tabToSelect;
            this.emitSelectedTab.emit(this.selectedTab);
        }
    }
}
